import cx from 'classnames'
import type React from 'react'

import type { SwitchDefaultProps as Props } from '../../types'
import css from './SwitchThin.module.scss'

const SwitchThin: React.FC<Props> = ({
  classes = {},
  checked,
  disabled = false,
  onChange,
}) => {
  const cNames = {
    container: cx(css.container, classes.container, {
      [css.checked]: checked,
      [css.disabled]: disabled,
    }),
    bar: cx(css.bar, classes.bar),
    control: cx(css.control, classes.control),
  }

  return (
    <div
      className={cNames.container}
      onClick={() => {
        if (!disabled) {
          onChange?.(!checked)
        }
      }}
    >
      <div className={cNames.bar} />
      <div className={cNames.control} />
    </div>
  )
}

export default SwitchThin
